import useAutoId from "web/hooks/behaviour/useAutoId"
import classNames from "classnames"

const OperatorRadio = (props) => {
  const {
    id,
    name,
    value = {},
    kind,
    onChange,
    lookup_values,
    disabled = false,
    flexDirection = "row",
  } = props

  const radioId = useAutoId(id)

  function handleOnChange(e) {
    onChange({ value: e.target.value, kind })
  }

  const radios = lookup_values.map((lv) => {
    const checked = value && lv.value === value.value

    const spanClassName = classNames(
      "flex items-center space-x-2 flex-1 px-2 py-1 cursor-pointer",
      {
        "text-blue-600 font-bold": checked && !disabled,
        "bg-gray-600 text-white": checked && disabled,
        "text-gray-600": !checked,
        "hover:text-blue-600 hover:font-bold": !disabled,
      }
    )

    const labelValueClassName = classNames({
      "pl-2": lv.prefix,
    })

    const valueId = `${radioId}-${lv.value}`

    return (
      <div key={valueId} className={spanClassName}>
        <input
          id={valueId}
          type="radio"
          name={name}
          value={lv.value}
          checked={checked}
          onChange={handleOnChange}
          disabled={disabled}
          data-testid={`radio-input-${lv.value}`}
        />
        <label
          htmlFor={valueId}
          className="flex cursor-pointer"
          data-testid={`radio-label-${lv.value}`}
        >
          {lv.prefix && <div className="pr-1">{lv.prefix}</div>}
          <div className={labelValueClassName}>{lv.label}</div>
        </label>
      </div>
    )
  })

  const containerClassNames = classNames("flex text-sm", {
    "flex-col space-y-1": flexDirection === "col",
    "flex-row space-x-1": flexDirection !== "col",
  })

  return <div className={containerClassNames}>{radios}</div>
}

export default OperatorRadio
